import React from 'react';
import { FaServer, FaSyncAlt } from 'react-icons/fa';

export const checkBackend = async (setBackendAlive) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const res = await fetch(`${apiUrl}/`);
    setBackendAlive(res.ok);
  } catch {
    setBackendAlive(false);
  }
};

// バックエンド状態表示＋再チェックボタンのコンポーネント
export function BackendStatus({ backendAlive, onCheck }) {
  const statusLabel = backendAlive === null ? '未確認' : backendAlive ? '稼働中' : '停止中';
  const statusClass =
    backendAlive === null
      ? 'bg-gray-100 text-gray-600'
      : backendAlive
      ? 'bg-green-100 text-green-700'
      : 'bg-red-100 text-red-700';
  const statusMessage =
    backendAlive === null
      ? 'チェックして状態を確認してください。'
      : backendAlive
      ? '接続に成功しました。'
      : '接続できません。設定を確認してください。';

  return (
    <div className="flex flex-col gap-2 text-sm">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <FaServer className="text-gray-700" />
          <span className="font-semibold text-gray-800">バックエンド</span>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs w-fit ${statusClass}`}>
          {statusLabel}
        </span>
      </div>
      <p className="text-gray-600 leading-relaxed">{statusMessage}</p>
      <div className="flex justify-start">
        <button
          onClick={onCheck}
          className="btn btn--small"
        >
          <FaSyncAlt className="btn__icon" />
          <span>再チェック</span>
        </button>
      </div>
    </div>
  );
}